import { Routes, Route } from 'react-router-dom'
import Promotions from './Promotions'
import EndUser from './end-user/Page'
import Dealer from './dealer/Page'

const Page = () => {
  return (
    <Routes>
      <Route path='/dealer/*' element={<Dealer />} />
      <Route path='/end-user/*' element={<EndUser />} />
      <Route path='/*' element={<Promotions />} />
    </Routes>
  )
}

export default Page
